<template>
  <div class="right checkbox_group">
    <p class="check_all" v-if="showSelectAll && !disabled">
      <input type="checkbox"
             id="select-all"
             name="name"
             v-model="selectAll"
             @change="onSelectAll"
      >
      <label for="select-all" v-translate>Označit vše</label>
    </p>
    <ul class="settings">
        <list-checkbox-input
            v-for="item in options"
            :key="item.id"
            :id="item.id"
            :name="item.name"
            :selected-entities="selectedItems"
            @input="setSelectedItems"
            :disabled="disabled"
        >
          {{ item.name }}
        </list-checkbox-input>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CheckboxList",
  props: {

    value: {
      type: Array,
      default: ()=>{return [];}
    },
    options: Array,
    showSelectAll: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: 'CheckboxList'
    }
  },
  data(){
    return{
      selectedItems: this.value,
      selectAll: false,
    }
  },
  methods: {
    setSelectedItems(item){
      if(item.checked && !this.selectedItems.includes(item.id)){
        this.selectedItems.push(item.id);
      }else if(!item.checked && this.selectedItems.includes(item.id)){
        this.selectedItems = this.selectedItems.filter(i => i !== item.id);
      }
      this.selectAll = this.selectedItems.length === this.options.length;

      this.onInput();
    },
    onInput(){
      this.$emit('input', this.selectedItems);
    },
    onSelectAll(){
      if(this.selectAll){
        this.selectedItems = this.options.map(item => item.id);
      }else{
        this.selectedItems = [];
      }
      this.onInput();
    },
  },
  watch: {
    value(){
      this.selectedItems = this.value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/CheckboxList.vue